import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import axios from 'axios';

export type WorkspaceAnalyticsEmbed = Diagonal.Workspaces.Data.WorkspaceAnalyticsEmbedData;

// Root-relative so it resolves against whatever host the page renders on (workspace
// subdomain or custom domain). Gated to system administrators; returns the passworded
// Fathom embed URL, or null when no site is provisioned.
const ANALYTICS_EMBED_ROUTE = '/api/workspace/analytics/embed';

export function getWorkspaceAnalyticsEmbedQueryKey() {
  return ['workspace', 'analytics', 'embed'] as const;
}

export function useWorkspaceAnalyticsEmbed(): UseQueryResult<WorkspaceAnalyticsEmbed> {
  return useQuery({
    queryKey: getWorkspaceAnalyticsEmbedQueryKey(),
    queryFn: async () => {
      const response = await axios.get<WorkspaceAnalyticsEmbed>(ANALYTICS_EMBED_ROUTE);

      return response.data;
    }
  });
}
